
import ConnectedExchangeRequests from './connectors/ConnectedExchangeRequests/ConnectedExchangeRequests'

const ExchangeRequestsPage = () => (
    <ConnectedExchangeRequests />
)

export default ExchangeRequestsPage
